// Enum für die unterstützten Event-Typen

export const EventType = Object.freeze({
    TOUCH_EVENTS: 'Touch-Events',
    MOUSE_EVENTS: 'Mouse-Events',
    POINTER_EVENTS: 'Pointer-Events',
    NONE: 'No supported Event'
});

export let SupportedEventType = EventType.NONE;

function detectSupportedEventType() {
    const supportsPointer = 'onpointerdown' in window;
    const supportsTouch = window.matchMedia("(pointer: coarse)").matches;
    const supportsMouse = 'onmousedown' in window;

    if (supportsPointer) {
        return EventType.POINTER_EVENTS;
    } else if (supportsTouch) {
        return EventType.TOUCH_EVENTS;
    } else if (supportsMouse) {
        return EventType.MOUSE_EVENTS;
    } else {
        return EventType.NONE;
    }
}

SupportedEventType = detectSupportedEventType();

export function callIfPointerSupported(functionToCall, e, args = null, supportedButtons = "left") {
    if (SupportedEventType === EventType.POINTER_EVENTS) {
        if(!e){
            console.warn("callIfPointerSupported -> called without event; event will not work");
            return;
        }

        const buttonClicked = e?.nativeEvent?.button;
        const isSupported =
        supportedButtons === "both" ||
        (supportedButtons === "left" && buttonClicked === 0) ||
        (supportedButtons === "right" && buttonClicked === 2);

        if (isSupported) {
            functionToCall(args);
        }
    }
}

export function callIfTouchSupported(functionToCall, args = null){
    if(SupportedEventType === EventType.TOUCH_EVENTS){
        functionToCall(args);
    }
}

export function callIfMouseSupported(functionToCall, e, args = null, supportedButtons = "left"){
    if(SupportedEventType === EventType.MOUSE_EVENTS){
        if(!e){
            console.warn("callIfMouseSupported -> called without event; event will not work");
            return;
        }

        const buttonClicked = e?.nativeEvent?.button;
        const isSupported =
            supportedButtons === "both" ||
            (supportedButtons === "left" && buttonClicked === 0) ||
            (supportedButtons === "right" && buttonClicked === 2);

        if(isSupported){
            functionToCall(args);
        }
    }
}